(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/store/assets/store.js') >= 0) return;  svs.modules.push('/components/marketplace-data/store/assets/store.js');
"use strict";

const browseGames = svs.components.marketplaceData.browseGames;
setGlobal('svs.components.marketplaceData.store.createStore', _ref => {
  let _ref$initialState = _ref.initialState,
    initialState = _ref$initialState === void 0 ? {} : _ref$initialState,
    _ref$middlewares = _ref.middlewares,
    middlewares = _ref$middlewares === void 0 ? [] : _ref$middlewares,
    reducers = _ref.reducers;
  const reducer = RTK.combineReducers(reducers);
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || RTK.compose;
  const enhancer = composeEnhancers(RTK.applyMiddleware(...middlewares));
  const store = RTK.createStore(reducer, initialState, enhancer);
  store.dispatch(browseGames.actions.loadFromQueryString());
  return store;
});

 })(window);